import React from 'react';

const Contact = () => {
    return (
        <div>
            <h1>Developer Sleeping  .........../////........</h1>
        </div>
    );
};

export default Contact;